module.exports = __webpack_public_path__ + "static/media/palace.45b098bf.svg";